<template lang="pug">
#concept
  .contents
    BuildService(:visibleMovie="true")
    Movie
    CoreValue(:visibleMovie="true")
</template>

<script>
import BuildService from './templates/build_service.vue'
import CoreValue from './templates/corevalue.vue'
import Movie from './atoms/Movie.vue'

export default {
  name: 'concept',
  components: {
    BuildService,
    CoreValue,
    Movie
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
@import '../assets/stylesheets/variables';
@import '../assets/stylesheets/mixins';

.footer {
  @include bpOnlyPc() {
    flex-direction: row;
    justify-content: center;
  }
  @include bpOnlySp() {
    flex-direction: column;
    align-items: center;
  }
  display: flex;
  background: $buildNavy;
  color: $white;
  padding-bottom: 90px;
  font-size: 14px;
  font-weight: bold;
  &_link {
    @include bpOnlyPc() {
      margin-right: 60px;
    }
    @include bpOnlySp() {
      margin-bottom: 30px;
    }
    text-decoration: underline;
  }
}
</style>
